export default  {
  bindings: {
    value: '='
  },
  controller: 'categoriesSelectController',
  template: require('../views/categories.select.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/categories.select.component.js